import {WorkingHoursDayInfo} from '../../data';

export const updateTimeForAllWeekDays = (
  days: WorkingHoursDayInfo[],
  newTime: {startTimeLocal?: string; endTimeLocal?: string},
): WorkingHoursDayInfo[] => {
  return days.map((day) => {
    const newTimes = day.times.map((time) => ({
      ...time,
      ...newTime,
    }));
    return {...day, times: newTimes};
  });
};
